import { Injectable } from '@angular/core'

import { APIService } from 'api'

@Injectable({ providedIn: 'root' })
export class ClientSideURLService {
  constructor (private api: APIService) { }

  async getPathUrl (path: string, platform: string | null): Promise<string> {
    const response = await this.api.private.getClientSideURL({
      clientSidePathEndpointRequest: {
        serverSidePath: path,
        platform: platform ?? 'win',
      },
    })
    return response.clientSideUrl
  }
}
